<div
  id="strength"
  #strength
>
  <span class="lato black bar-label">{{barLabel}}</span>
  <ul id="strengthBar">
    <li
      class="point"
      [style.background-color]="bar0"
    ></li>
    <li
      class="point"
      [style.background-color]="bar1"
    ></li>
    <li
      class="point"
      [style.background-color]="bar2"
    ></li>
    <li
      class="point"
      [style.background-color]="bar3"
    ></li>
    <li
      class="point"
      [style.background-color]="bar4"
    ></li>
  </ul>
</div>